import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import config from '../utils/config';
import MainCard from './MainCard'; 

const ResetPassword = () => {
    const { token } = useParams();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setMessage('Passwords do not match');
            return;
        }

        try {
            const response = await fetch(`${config.apiBaseUrl}/reset-password/${token}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ password }),
            });

            const data = await response.json();
            // console.log('Response:', data); // Log the response for debugging

            if (response.ok) {
                setMessage('Password has been reset successfully.');
            } else {
                setMessage(data.error);
            }
        } catch (error) {
            console.error('Error:', error); // Log the error for debugging
            setMessage('An error occurred. Please try again.');
        }
    };

    return (
        <div className="h-[450px] w-[450px] md:h-[750px] md:w-[750px] flex flex-col justify-center items-center">
        <MainCard>
            <h1 className="text-black text-[24px] md:text-[34px] w-full font-semibold font-['Inter'] mb-3">Reset Password</h1>
        <form onSubmit={handleSubmit} className='w-[300px] md:w-[450px] h-auto justify-between gap-3 items-start flex flex-col'>
            <div className="flex flex-col text-left justify-start items-start w-[350px] md:w-[750px]">
                <div className="w-[350px] justify-between gap-2 items-start flex flex-col">
                    <span className='text-sm text-slate-600'>
                        New Password
                    </span>
                </div>
            <input
                type="password"
                placeholder="New Password"
                className={`py-1 px-[1px] md:px-3 h-[39px] rounded-md border w-[300px] md:w-[450px] border-slate-300`}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
            />
            <div className="w-[350px] justify-between gap-2 items-start flex flex-col mt-4">
                <span className='text-sm text-slate-600'>
                    Confirm New Password
                </span>
            </div>
            <input
                type="password"
                placeholder="Confirm Password"
                className={`py-1 px-[1px] md:px-3 h-[39px] rounded-md border w-[300px] md:w-[450px] border-slate-300`}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
            />
        </div>
        <div className="w-full mt-5 flex flex-col items-center">
            <button 
                className="w-[11rem] justify-center items-center text-white bg-shi-green border-shi-green text-sm md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border flex" 
                type="submit">
                Reset Password
            </button>
        </div>
            {message && <p>{message}</p>}
        </form>
        </MainCard>
        </div>
    );
};

export default ResetPassword;